<template>
  <div class="call-details-blocks files-preview">
    <div class="block">
      <div
        v-for="file in files"
        class="file"
        :key="file.fileUrl"
      >
        <file-preview :file="file"/>
      </div>
    </div>
  </div>
</template>

<script>
  import FilePreview from "./FilePreview";

  export default {
    name: "FilesPreview",
    components: {FilePreview},
    props: {
      files: {
        type: Array
      }
    }
  }
</script>

<style lang="scss">
  @import "FilesPreview";
</style>
